import styled from "styled-components"

const StyledSection = styled.section`
  .hero-text {
    margin-top: 6rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .one-line {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .leaf {
    margin-left: 1rem;
    margin-right: 1rem;
    width: 30px;
  }
  .h-line {
    width: 5rem;
    height: 1px;
    color: ${({ theme }) => theme.colors.lightColor};
  }
  h6 {
    font-size: 22px;
    letter-spacing: 4px;
    color: ${({ theme }) => theme.colors.lightColor};
    font-weight: 500;
    text-align: center;
  }
  h1 {
    line-height: 200px;
    font-size: 200px;
    letter-spacing: 4px;
    color: #ffffff;
    font-weight: 700;
    text-align: center;
    filter: drop-shadow(3.507px 7.19px 3px rgba(183, 184, 186, 0.14));
    overflow: hidden;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.xl)} {
    h1 {
      font-size: 140px;
      line-height: 140px;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.md)} {
    h1 {
      font-size: 80px;
      line-height: 80px;
    }
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    h1 {
      font-size: 40px;
      line-height: 60px;
    }
  }
`
export default StyledSection
